import dom from "../../../../common/ts/core/dom";
import {EventBus} from "../../../../common/ts/events/EventBus";
import {BreadcrumbClickedEvent} from "./events";
import eventHandlers from "./eventHandlers";

const BREADCRUMB_SELECTOR = ".js-breadcrumb-custom-item"
function init(ev: any = EventBus.getInstance()) {
    const eventBus: EventBus = ev;
    const breadcrumbElement = dom.select(BREADCRUMB_SELECTOR);
    eventHandlers.init();

    eventBus.emit(new dom.AddClickListenerEvent({
        selector:BREADCRUMB_SELECTOR,
        listener: function (this: HTMLElement) {
            const level = this.getAttribute('data-breadcrumb-level')!;
            eventBus.emit(
                new BreadcrumbClickedEvent({level})
            )
        }
    }));
}

export default {
    init
}